import React, { useMemo, useState } from 'react';
import { TabsContext, useTabsContext } from './context';
import { TabPane, Tabs as TabList, Wrapper } from './styles';
import { Tab } from './tab';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Pane = function Pane() {
  var _useTabsContext = useTabsContext(),
      current = _useTabsContext.current;

  return current ? ___EmotionJSX(TabPane, null, current.children) : null;
};

var Children = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  return ___EmotionJSX(TabList, null, children);
});

var Tabs = function Tabs(_ref2) {
  var activeId = _ref2.activeId,
      children = _ref2.children;

  var _useState = useState(undefined),
      current = _useState[0],
      setCurrent = _useState[1];

  var value = useMemo(function () {
    return {
      activeId: activeId,
      current: current,
      setCurrent: setCurrent
    };
  }, [current, activeId]);
  return ___EmotionJSX(TabsContext.Provider, {
    value: value
  }, ___EmotionJSX(Wrapper, null, ___EmotionJSX(Children, {
    children: children
  }), ___EmotionJSX(Pane, null)));
};

Tabs.displayName = 'Tabs';
Tabs.Tab = Tab;
export { Tabs };

if (typeof Tabs !== 'undefined' && Tabs && Tabs === Object(Tabs) && Object.isExtensible(Tabs) && !Object.prototype.hasOwnProperty.call(Tabs, '__filemeta')) {
  Object.defineProperty(Tabs, '__filemeta', {
    configurable: true,
    value: {
      name: "Tabs",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tabs/index.js"
    }
  });
}